import React from "react";
import "./confirmLocation.css";

import Logo from "../../../images/RED-FOX-LOGO.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";

import pinImage from "../../../images/icons/location-pin.png";

import { useShipping } from "../../../contexts/ShippingContext";

import { useOrder } from "../../../contexts/OrderContext";

export default function ConfirmLocation({ selectedLocation, onErase }) {
  const { getAllPrices } = useOrder();
  const { priceAfterDiscounts } = getAllPrices();

  const loc = selectedLocation();

  const { submitShipping } = useShipping();

  async function handleSubmit(e) {
    e.preventDefault();
    await submitShipping(loc.DeliverLocationId);
  }

  return (
    <div className="location-main-part detail-location-main-part">
      <div className="location-header">
        <div className="header-icon">
          <img src={Logo} alt="logo" />
        </div>
        <div className="header-text">
          <span className="cafe-name">RED FOX</span>
          <span className="cafe-name-desc">Coffee Shop</span>
          <span className="header-main-text">من نمیام تو بیا</span>
        </div>
      </div>

      <div className="location-detail-box">
        <div className="location-item confirm-item">
          <img src={pinImage} alt="" className="location-item-image" />
          {loc.LocationTitle}
        </div>

        <div className="detail-text">
          <div className="detail-text-line">
            <span>مبلغ قابل پرداخت</span>
            <span className="detail-text-line-result">
              {priceAfterDiscounts} تومان
            </span>
          </div>
          {/* <div className="detail-text-line">
            <span>فاصله با شما</span>
            <span className="detail-text-line-result">5 کیلومتر</span>
          </div> */}

          <div className="detail-box-buttons">
            <button
              className="red-submit-btn detail-box-btn"
              onClick={handleSubmit}
            >
              ثبت سفارش
            </button>
          </div>
        </div>
      </div>
      <button className="detail-return-button" onClick={onErase}>
        انتخاب آدرس دیگه
        <FontAwesomeIcon icon={faChevronLeft} className="detail-box-icon" />
      </button>
    </div>
  );
}
